import React from 'react';
import ColorStrip from './Core/ColorStrip';

const BibleBooksColorStrip = (props) => {
    const filters = [
        { label: 'The Law', value: 'The Law' },
        { label: "Israel's Story", value: 'Historical' },
        { label: 'Wisdom', value: 'Wisdom' },
        { label: 'Major Prophets', value: 'Major Prophets' },
        { label: 'Minor Prophets', value: 'Minor Prophets' },
        { label: 'Jesus & Acts', value: 'Gospel & Acts' },
        { label: "Paul's Letters", value: 'Pauline Epistles' },
        { label: 'Other Letters', value: 'General Epistles' },
    ];
    const { onSelect } = props;

    const handleSelect = (label) => {
        if (label === '') {
            onSelect('All');
            return;
        }

        const selectedFilter = filters.find((filter) => filter.label === label);

        if (onSelect) {
            onSelect(selectedFilter.value, filters.indexOf(selectedFilter));
        } else {
            console.error('expected onSelect handler');
        }

        console.log('BibleBooksColorStrip: Selected: ', selectedFilter.value);
    };

    return (
        <div>
            <ColorStrip onSelect={handleSelect} items={filters.map((filter) => filter.label)} />
        </div>
    );
};

export default BibleBooksColorStrip;
